export function canExposeInternals() {
  return process.env.NODE_ENV === 'development' || process.env.REACT_APP_ENV !== 'production';
}
